export const QUICK_ACTIONS_ROOT = 'quick-actions-root';
export const FLOATING_ADD_BUTTON_QUICK_ACTIONS = 'floating-add-button-quick-actions';
